import { Component, OnInit } from '@angular/core';
// import { DataProviderService } from '../../service/data-provider.service';
import { DataProviderService } from '../service/data-provider.service';

@Component({
  selector: 'app-workshop',
  templateUrl: './workshop.component.html',
  styleUrls: ['./workshop.component.css']
})
export class WorkshopComponent implements OnInit {
  Patents: any;
  Reports: any;
  Invited: any;
  biomechanics: any;
  manufacturing: any;
  authors: any;
  neuroscience: any;
  ergonomics: any;
  perceptional: any;
  biomaterials: any;
  orthopaedic: any;
  News: any;
  simulation: any;
  mining: any;
  constructor(private datapro: DataProviderService) {
    this.Patents = this.datapro.patents.Patents
    this.Reports = this.datapro.reports.Reports
    this.Invited = this.datapro.invited.Invited
    this.biomechanics = this.datapro.biomechanics
    this.manufacturing = this.datapro.manufacturing
    this.neuroscience = this.datapro.neuroscience
    this.ergonomics = this.datapro.ergonomics
    this.perceptional = this.datapro.perceptional
    this.biomaterials = this.datapro.biomaterials
    this.orthopaedic = this.datapro.orthopaedic
    this.simulation = this.datapro.simulation
    this.mining = this.datapro.mining
    this.authors = this.datapro.authors;
    this.News = this.datapro.newSinglesample
    // console.log(this.datapro.son)
  }
  ngOnInit() {
    window.scrollTo(0, 0);

  }
}
